import { CellProps, Hooks, Row } from 'react-table';

import { Visible } from 'coreOld/components';
import { Icon } from 'coreOld/elements';

import { Centered, iconStyle } from './tableStyle';

export const renderInfoColumn = (
  hooks: Hooks<object>,
  showInfoIcon: boolean,
  onShowInfoClick: (row: Row) => void
) => {
  if (!showInfoIcon || !onShowInfoClick) {
    return;
  }

  return hooks.visibleColumns.push((columns) => [
    ...columns,
    {
      id: 'info',
      minWidth: 30,
      width: 30,
      Cell: ({ row }: CellProps<object, any>) => {
        return (
          <Centered>
            <Visible when={showInfoIcon}>
              <Icon name={Icon.INFO} onClick={() => onShowInfoClick(row)} style={iconStyle} />
            </Visible>
          </Centered>
        );
      },
    },
  ]);
};
